import React, { useEffect, useState } from 'react';
import { gccFlowsService } from '../../services/gccFlowsService';
import LoadingSpinner from '../../components/shared/LoadingSpinner';
import CollapsibleSection from '../signals/components/CollapsibleSection';

const PROVIDER_BADGE = {
  MSCI: 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-400',
  FTSE: 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400',
  other: 'bg-gray-100 dark:bg-gray-900/30 text-gray-700 dark:text-gray-400',
};

const IndexEventsPage = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await gccFlowsService.getIndexEvents();
        setEvents(Array.isArray(res.data) ? res.data : (res.data?.results || []));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <LoadingSpinner message="Loading index events..." />;

  const today = new Date().toISOString().slice(0, 10);
  const upcoming = events.filter((e) => !e.results_date || e.results_date >= today);
  const past = events.filter((e) => e.results_date && e.results_date < today);

  return (
    <div>
      <Section title={`Upcoming (${upcoming.length})`} rows={upcoming} />
      <Section title={`Past (${past.length})`} rows={past} defaultOpen={false} />
    </div>
  );
};

const Section = ({ title, rows, defaultOpen = true }) => (
  <CollapsibleSection title={title} defaultOpen={defaultOpen}>
    {rows.length === 0 ? (
      <div className="text-center py-6 text-sm text-gray-500 dark:text-gray-400">No events.</div>
    ) : (
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="bg-gray-50 dark:bg-[#0d1117]">
            <tr>
              <th className="px-3 py-2 text-left text-[10px] uppercase tracking-wider text-gray-500 dark:text-gray-400">Provider</th>
              <th className="px-3 py-2 text-left text-[10px] uppercase tracking-wider text-gray-500 dark:text-gray-400">Event</th>
              <th className="px-3 py-2 text-left text-[10px] uppercase tracking-wider text-gray-500 dark:text-gray-400">Results</th>
              <th className="px-3 py-2 text-left text-[10px] uppercase tracking-wider text-gray-500 dark:text-gray-400">MENA ex-UAE Impl.</th>
              <th className="px-3 py-2 text-left text-[10px] uppercase tracking-wider text-gray-500 dark:text-gray-400">UAE Impl.</th>
              <th className="px-3 py-2 text-left text-[10px] uppercase tracking-wider text-gray-500 dark:text-gray-400">Effective</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
            {rows.map((e) => (
              <tr key={e.id} className="hover:bg-gray-50 dark:hover:bg-gray-800/50">
                <td className="px-3 py-1.5">
                  <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-medium uppercase ${PROVIDER_BADGE[e.provider] || PROVIDER_BADGE.other}`}>
                    {e.provider || 'other'}
                  </span>
                </td>
                <td className="px-3 py-1.5 text-gray-800 dark:text-gray-200">{e.event_name}</td>
                <td className="px-3 py-1.5 text-gray-700 dark:text-gray-300 whitespace-nowrap">{e.results_date || '-'}</td>
                <td className="px-3 py-1.5 text-gray-700 dark:text-gray-300 whitespace-nowrap">{e.impl_date_mena_ex_uae || '-'}</td>
                <td className="px-3 py-1.5 text-gray-700 dark:text-gray-300 whitespace-nowrap">{e.impl_date_uae || '-'}</td>
                <td className="px-3 py-1.5 text-gray-700 dark:text-gray-300 whitespace-nowrap">{e.effective_date || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </CollapsibleSection>
);

export default IndexEventsPage;
